export const currencyFormater = Intl.NumberFormat('en-US', {
	style: 'decimal',
	maximumFractionDigits: 2,
	minimumFractionDigits: 2,
})
